import type React from 'react'
import type { ReactElement } from 'react'

export function IconAlertWarning(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={24} height={24} xmlns={'http://www.w3.org/2000/svg'} viewBox={'0 0 24 24'} {...props}>
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M12 6.5C12.5063 6.5 12.9167 6.91041 12.9167 7.41667V12.9167C12.9167 13.4229 12.5063 13.8333 12 13.8333C11.4937 13.8333 11.0833 13.4229 11.0833 12.9167V7.41667C11.0833 6.91041 11.4937 6.5 12 6.5Z'
        }
        fill={'currentcolor'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M7.15074 1.26849C7.32264 1.09658 7.5558 1 7.79892 1H16.2011C16.4442 1 16.6774 1.09658 16.8493 1.26849L22.7315 7.15074C22.9034 7.32264 23 7.5558 23 7.79892V16.2011C23 16.4442 22.9034 16.6774 22.7315 16.8493L16.8493 22.7315C16.6774 22.9034 16.4442 23 16.2011 23H7.79892C7.5558 23 7.32264 22.9034 7.15074 22.7315L1.26849 16.8493C1.09658 16.6774 1 16.4442 1 16.2011V7.79892C1 7.5558 1.09658 7.32264 1.26849 7.15074L7.15074 1.26849ZM8.17861 2.83333L2.83333 8.17861V15.8214L8.17861 21.1667H15.8214L21.1667 15.8214V8.17861L15.8214 2.83333H8.17861Z'
        }
        fill={'currentcolor'}
      />
      <path
        fillRule={'evenodd'}
        clipRule={'evenodd'}
        d={
          'M12 15.6577C12.5063 15.6577 12.9167 16.0681 12.9167 16.5744V16.5835C12.9167 17.0898 12.5063 17.5002 12 17.5002C11.4937 17.5002 11.0833 17.0898 11.0833 16.5835V16.5744C11.0833 16.0681 11.4937 15.6577 12 15.6577Z'
        }
        fill={'currentcolor'}
      />
    </svg>
  )
}
